module.exports = __webpack_public_path__ + "img/fitshow-title-back-image-2.796797e8.jpg";